import React, { useState } from 'react';
import styled from 'styled-components';
import { useCookies } from 'react-cookie';

import { deleteLicenseKey, getFullLicense } from '../../../api/bots';
import { COOKIE } from '../../../constants';
import { TidalButton } from '../../common/button';
import Bin from '../../svgs/Bin';
import Eye from '../../svgs/Eye';
import Key from '../../svgs/Key';
import { TailSpin } from 'react-loader-spinner';

const TidalDashboardDeleteBotKeyModalWrapper = styled.div`
  border-radius: 14px;
  padding: 24px 28px;
  background-color: ${(props) => props.theme.colors.background};
  border: 1px solid ${(props) => props.theme.colors.borderColors[1]};
  box-shadow: 0px 26px 87px rgba(27, 31, 38, 0.25);
  width: 518px;
  max-width: 100%;
`;

const TidalDashboardDeleteBoyKeyInfoRow = styled.div`
  display: flex;
  grid-gap: 0 12px;
  justify-items: center;
  align-items: center;
  margin: 0 auto;
  margin-top: 32px;
  width: fit-content;
  & > .icon-wrapper {
    height: 40px;
    width: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${(props) => `${props.theme.colors.tags[4]}3d`};
  }
  & > .text {
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    color: ${(props) => props.theme.colors.text[3]};
  }
`;

const TidalDashboardDeleteBoyKeyTitle = styled.div`
  max-width: 327px;
  margin: 0 auto;
  margin-top: 32px;
  & > .title {
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    color: ${(props) => props.theme.colors.text[1]};
    text-align: center;
  }
  & > .text {
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: ${(props) => props.theme.colors.text[0]};
    margin-top: 24px;
    margin-bottom: 32px;
  }
`;

const TidalDashboardDeleteBoykeyLicenseRow = styled.div`
  display: grid;
  grid-template-columns: 78px 1fr;
  border-top: 1px solid ${(props) => props.theme.colors.borderColors[1]};
  padding-top: 24px;
  grid-gap: 20px;
  div > img {
    border-radius: 8px;
    background-color: black;
  }
  div > .bot-name {
    margin-bottom: 13px;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: ${(props) => props.theme.colors.text[1]};

`;

const TidalDashboardDeleteBotKeyComponent = styled.div`
  margin-bottom: 0px;
  & > .tidal-dashboard-vault-card-key-row {
    display: grid;
    grid-template-columns: 40px 1fr 16px;
    align-items: center;
    grid-gap: 11px;
    @media only screen and (max-width: 320px) {
      grid-template-columns: 30px 1fr 16px;
    }
    & > .key-icon-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
      height: 40px;
      width: 40px;
      @media only screen and (max-width: 320px) {
        width: 30px;
        height: 30px;
      }
      background-color: ${(props) => props.theme.colors.tags[5]};
    }
    & > .key-wrapper {
      margin-right: 16px;
      & > .label {
        font-weight: 600;
        font-size: 12px;
        line-height: 15px;
        color: ${(props) => props.theme.colors.text[0]};
      }
      .license-key-text {
        font-weight: 600;
        font-size: 12px;
        line-height: 15px;
        color: ${(props) => props.theme.colors.text[1]};
      }
      & > .key-row {
        display: flex;
        align-items: center;
        grid-gap: 4px;

        .obstructed-pattern {
          display: flex;
          grid-gap: 3px;
          wrap: nowrap;
          .cirle {
            height: 5px;
            width: 5px;
            border-radius: 50%;
            background-color: ${(props) => props.theme.colors.text[0]};
          }
        }
      }
    }
  }
`;

const TidalDashboardDeleteBotKeyModalFooter = styled.div`
  margin-top: 24px;
  padding-top: 26px;
  border-top: 1px solid ${(props) => props.theme.colors.borderColors[1]};
  display: grid;
  grid-template-columns: 0.6fr 1fr;
  grid-gap: 16px;
  @media only screen and (max-width: 295px) {
    grid-template-columns: 0.4fr 1fr;
    grid-gap: 8px;
  }
`;

const TidalDashboardBotVaultCardObfuscateButton = styled.button``;

interface ITidalDashboardDeleteKeyModal {
  onClose: () => void;
  onDeleted: () => void;
  botName: string;
  botImage: string;
  licenseKey: string;
  id: string;
}

const TidalDashboardDeleteBotKeyModal = ({
  botImage,
  botName,
  licenseKey,
  id,
  onClose,
  onDeleted,
}: ITidalDashboardDeleteKeyModal): JSX.Element => {
  const [isObfuscated, setIsObfuscated] = React.useState(true);

  const [fullLicenseKey, setFullLicenseKey] = useState('');
  const [isFullKeyLoading, setIsFullKeyLoading] = useState(false);

  const [isDeleting, setIsDeleting] = useState(false);

  const handleDeleteBotkey = async () => {
    setIsDeleting(true);
    try {
      await deleteLicenseKey({
        licenseId: id,
      });
      onDeleted();
    } catch (e) {}
    setIsDeleting(false);
  };

  const handleGetFullLicenseKey = async () => {
    setIsFullKeyLoading(true);
    try {
      const res = await getFullLicense({
        licenseId: id,
      });
      setFullLicenseKey(res.licenseKey);
    } catch (e) {}
    setIsFullKeyLoading(false);
  };

  return (
    <TidalDashboardDeleteBotKeyModalWrapper>
      <TidalDashboardDeleteBoyKeyInfoRow>
        <div className="icon-wrapper">
          <Bin />
        </div>
        <p className="text">Delete key</p>
      </TidalDashboardDeleteBoyKeyInfoRow>
      <TidalDashboardDeleteBoyKeyTitle>
        <p className="title">Are you sure you want to delete this key?</p>
        <p className="text">This action cannot be undone.</p>
      </TidalDashboardDeleteBoyKeyTitle>
      <TidalDashboardDeleteBoykeyLicenseRow>
        <div>
          <img alt="" src={`/assets/dashboard/bots/${botImage}`} />
        </div>
        <div>
          <p className="bot-name">{botName}</p>
          <TidalDashboardDeleteBotKeyComponent>
            <div className="tidal-dashboard-vault-card-key-row">
              <div className="key-icon-wrapper">
                <Key />
              </div>
              <div className="key-wrapper">
                <p className="label">License Key</p>
                {isObfuscated && (
                  <div className="key-row">
                    <div className="obstructed-pattern">
                      {Array(
                        Math.ceil(licenseKey.length - licenseKey.length / 4) -
                          1,
                      )
                        .fill(0)
                        .map((a) => (
                          <div className="cirle"></div>
                        ))}
                    </div>
                    <p className="license-key-text">{licenseKey}</p>
                  </div>
                )}
                {!isObfuscated && isFullKeyLoading && (
                  <div>
                    <TailSpin color="#0000ff" height={16} width={16} />
                  </div>
                )}
                {!isObfuscated && (
                  <p className="license-key-text">{fullLicenseKey}</p>
                )}
              </div>
              <TidalDashboardBotVaultCardObfuscateButton
                onClick={() => {
                  if (isObfuscated && fullLicenseKey.length == 0) {
                    handleGetFullLicenseKey();
                  }
                  setIsObfuscated(!isObfuscated);
                }}
              >
                <Eye />
              </TidalDashboardBotVaultCardObfuscateButton>
            </div>
          </TidalDashboardDeleteBotKeyComponent>
        </div>
      </TidalDashboardDeleteBoykeyLicenseRow>
      <TidalDashboardDeleteBotKeyModalFooter>
        <TidalButton
          text="Cancel"
          type="default"
          tint={true}
          onClick={onClose}
        />
        <TidalButton
          text="Yes, delete key"
          type="error"
          tint={false}
          isLoading={isDeleting}
          onClick={handleDeleteBotkey}
        />
      </TidalDashboardDeleteBotKeyModalFooter>
    </TidalDashboardDeleteBotKeyModalWrapper>
  );
};

export default TidalDashboardDeleteBotKeyModal;
